import { BriefcaseArrowLeftRightOutlineIcon } from './BriefcaseArrowLeftRightOutlineIcon';

/**
 * author: Michael Irigoyen
 * id FA334ED0-09E4-4FB3-AF2A-20715D19A1E5
 * name briefcase-arrow-left-right-outline
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/briefcase-arrow-left-right-outline.svg
 * tags
 */
export const BriefcaseTransferOutlineIcon = BriefcaseArrowLeftRightOutlineIcon;
export default BriefcaseTransferOutlineIcon